import { render } from "./Bonteous.vue?vue&type=template&id=4dc058de"
import script from "./Bonteous.vue?vue&type=script&lang=js"
export * from "./Bonteous.vue?vue&type=script&lang=js"

import "./Bonteous.vue?vue&type=style&index=0&id=4dc058de&lang=css"
script.render = render

export default script